import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/movies';

const footerLinks = {
  快捷导航: [
    { label: '首页', path: '/' },
    { label: '电影', path: '/category/movie' },
    { label: '电视剧', path: '/category/tv' },
    { label: '综艺', path: '/category/variety' },
    { label: '排行榜', path: '/category/movie' },
  ],
  关于我们: [
    { label: '品牌介绍', path: '/about' },
    { label: '用户口碑', path: '/about' },
    { label: '联系方式', path: '/about' },
    { label: '常见问题', path: '/about' },
  ],
  热门推荐: [
    { label: '最新电影', path: '/category/movie' },
    { label: '热播电视剧', path: '/category/tv' },
    { label: '热门综艺', path: '/category/variety' },
    { label: '高分推荐', path: '/category/movie' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-300/60">
      <div className="px-4 md:px-6 py-12 md:py-14 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-line text-background-50 text-lg"></i>
              </div>
              <span className="text-foreground-950 font-bold text-lg font-heading">
                91影视看片
              </span>
            </Link>
            <p className="text-foreground-600 text-sm leading-relaxed mb-4">
              {siteInfo.description.slice(0, 80)}...
            </p>
            <div className="flex items-center gap-3">
              <a href={siteInfo.socialLinks.weibo} target="_blank" rel="nofollow noopener" className="w-9 h-9 flex items-center justify-center bg-background-200 rounded-full text-foreground-500 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <span className="w-9 h-9 flex items-center justify-center bg-background-200 rounded-full text-foreground-500 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center bg-background-200 rounded-full text-foreground-500 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line"></i>
              </span>
            </div>
          </div>

          {/* Link groups */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-foreground-900 font-semibold text-sm mb-4">
                {title}
              </h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-foreground-600 hover:text-primary-500 text-sm transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="mt-10 pt-6 border-t border-background-300/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-500 text-xs">
            &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有 |{' '}
            <a href="#" className="hover:text-primary-500 transition-colors">京ICP备2024XXXXXXXX号</a>
          </p>
          <div className="flex items-center gap-4 text-foreground-500 text-xs">
            <a href="#" className="hover:text-primary-500 transition-colors">用户协议</a>
            <a href="#" className="hover:text-primary-500 transition-colors">隐私政策</a>
            <a href="#" className="hover:text-primary-500 transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}